import { Users } from "lucide-react";

export function EmptyKidsState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center text-gray-500">
      <Users className="w-10 h-10 mb-3 text-gray-300" />
      <p className="font-medium text-gray-700">No kids enrolled in this batch yet.</p>
      <p className="text-sm mt-1">Ask your admin to enroll players into this batch.</p>
    </div>
  );
}
